<template>
    <div>
        <b-row>
            <b-col lg="6">
                <b-form-group label="الواجب">
                    <validation-provider name="homework" vid="homework" rules="required" v-slot="{ errors }">
                        <v-select v-model="newItem.code" :options="activitiesCodes ? activitiesCodes : []" class="w-100"
                            label="label" value-field="value" :state="errors.length > 0 ? false : null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="اسم الواجب">
                    <validation-provider name="homework_name" vid="homework_name" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.homework_name" type="string"
                            :state="errors.length > 0 ? false : null" placeholder="اسم الواجب" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-group label="الوصف">
                    <validation-provider name="description" vid="description" rules="required" v-slot="{ errors }">
                        <b-form-textarea v-model="newItem.description" :state="errors.length > 0 ? false : null"
                            placeholder="الوصف" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="الثمرة التعليمية المستهدفة">
                    <validation-provider name="education_level" vid="education_level" rules="required"
                        v-slot="{ errors }">
                        <b-form-select v-model="newItem.education_level" :state="errors.length > 0 ? false : null"
                            :options="education_levels" />

                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-group label="يمكن الوصول له من">
                    <validation-provider name="from" vid="from" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.from" type="datetime-local"
                            :state="errors.length > 0 ? false : null" placeholder="يمكن الوصل له من" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="يمكن الوصل له حتى">
                    <validation-provider name="to" vid="to" rules="required" v-slot="{ errors }">
                        <b-form-input v-model="newItem.to" type="datetime-local"
                            :state="errors.length > 0 ? false : null" placeholder="يمكن الوصل له حتى" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-group label="نوع الواجب">
                    <validation-provider name="homework_type" vid="homework_type" rules="required" v-slot="{ errors }">
                        <b-form-select v-model="newItem.homework_type" :state="errors.length > 0 ? false : null"
                            :options="homework_types" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                </b-form-group>
            </b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col lg="6">
                <b-form-group label="السماح باعادة التسليم">
                    <b-form-checkbox-group v-model="newItem.allow_resubmit">
                        <b-form-checkbox value="true">نعم</b-form-checkbox>
                        <b-form-checkbox value="false">لا</b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="منع تسلييم الواجبات المتاخرة">
                    <b-form-checkbox-group v-model="newItem.disallow_delayed_homeworks">
                        <b-form-checkbox value="true">نعم</b-form-checkbox>
                        <b-form-checkbox value="false">لا</b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-group label="حجم الملف">
                    <b-form-select v-model="newItem.file_size" :options="file_sizes" />
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="العدد الأقصي للملفات يمكن تحميلها  ">
                    <b-form-select v-model="newItem.max_files_allowed_count" :options="max_files_count" />
                </b-form-group>
            </b-col>
        </b-row>

    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
export default {
    props: ['newItem', 'activitiesCodes'],
    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },
    data() {
        return {
            education_levels: [],
            homework_types: [],
            file_sizes: [],
            max_files_count: []
        }
    },
    created() {
        // Education Levels
        let e = ["CLO1", "CLO2", "CLO3"];
        this.education_levels = e.map((val) => {
            return val;
        });
        // Homework Types
        let h = ["نص مباشر", "تحميل ملفات"];
        this.homework_types = h.map((val) => {
            return val;
        });
        // File Sizes
        let f = ["5MB", "2MB", "1MB", "500KB", "100KB", "50KB", "10KB"];
        this.file_sizes = f.map((val) => {
            return val;
        });
        // Max Files Count
        let m = ["1", "2", "3", "4", "5"];
        this.max_files_count = m.map((val) => {
            return val;
        });
    }
}

</script>